<template>
  <div>
    <Pane/>

    <a-card class="container">
      <a-form-model :colon="false" :model="form" layout="inline" @keyup.enter.native="query">
        <a-form-model-item label="项目名称">
          <a-input v-model="form.projectName" style="width: 160px"/>
        </a-form-model-item>
        <a-form-model-item label="业主单位">
          <a-input v-model="form.ownerCompanyName" style="width: 160px"/>
        </a-form-model-item>
        <a-form-model-item label="项目类型">
          <a-select v-model="form.projectType" style="width: 120px" placeholder allow-clear>
            <a-select-option v-for="item in projectTrackType" :key="item.value" :value="item.value">{{
                item.name
              }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="分类">
          <a-select v-model="form.category" style="width: 100px" placeholder allow-clear>
            <a-select-option v-for="item in trackCategory" :key="item.value" :value="item.value">{{
                item.name
              }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="年份">
          <a-input v-model="form.year" style="width: 100px"/>
        </a-form-model-item>

        <a-form-model-item label="部门">
          <a-select v-model="form.deptId" style="width: 160px" placeholder="请选择部门" allow-clear>
            <a-select-option v-for="item in orgList" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-space>
            <a-button @click="query" type="primary">查询</a-button>
            <a-button @click="reset">重置</a-button>
          </a-space>
        </a-form-model-item>
      </a-form-model>

      <input
          ref="upload"
          style="display: none"
          type="file"
          :multiple="false"
          @change="onFileChange"
      />

      <Padding/>

      <div class="toolbar">
        <a-button type="primary" @click="handleAdd">新增项目</a-button>
        <a-button @click="handleEdit">编辑项目</a-button>
        <a-button @click="handleDelete">删除项目</a-button>
        <a-button @click="handleExport">导出项目</a-button>
        <a-button @click="handleImport">导入项目</a-button>
        <a-button @click="handleDownloadTemplate">下载模板</a-button>
      </div>

      <a-table
          bordered
          row-key="id"
          :data-source="list"
          :loading="loading"
          :scroll="{ x: 2100 }"
          @change="onChange"
          :pagination="{
          total,
          current,
          pageSize,
          showSizeChanger: true,
          showQuickJumper: true,
          pageSizeOptions: ['10', '20', '50', '100'],
          showTotal: (total) => `共 ${total} 条记录`,
        }"
          :row-selection="{ selectedRowKeys, onChange: onSelectChange, columnWidth: 60 }"
      >
        <a-table-column title="项目名称" data-index="projectName" width="300" fixed="left">
          <template slot-scope="text, record">
            <a-tooltip :title="text">
              <a @click="handleDetail(record)">{{ text }}</a>
            </a-tooltip>
          </template>
        </a-table-column>
        <a-table-column title="项目地点" data-index="projectLocation" width="120" fixed="left">
          <template slot-scope="text">
            <a-tooltip :title="text">
              <span>{{ text }}</span>
            </a-tooltip>
          </template>
        </a-table-column>
        <a-table-column title="业主单位" data-index="ownerCompanyName" width="140">
          <template slot-scope="text">
            <a-tooltip :title="text">
              <span>{{ text }}</span>
            </a-tooltip>
          </template>
        </a-table-column>
        <a-table-column title="项目类型" data-index="projectType" align="center" width="100">
          <template slot-scope="text">
            {{ dictName(projectTrackType, text) }}
          </template>
        </a-table-column>
        <a-table-column title="分类" data-index="category" align="center" width="60">
          <template slot-scope="text">
            {{ dictName(trackCategory, text) }}
          </template>
        </a-table-column>
        <a-table-column title="预计合同金额(万元)" data-index="expectedAmount" align="right" width="140"/>
        <a-table-column title="预计落地/开标时间" data-index="expectedTime" align="center" width="140"/>
        <a-table-column title="概率(%)" data-index="probability" align="center" width="80"/>
        <a-table-column title="登记部门" align="center" width="120">
          <template slot-scope="text, record">
            {{ record.registerAreaName || record.registerOrgName }}
          </template>
        </a-table-column>
        <a-table-column title="专职经营人员" data-index="fulltimeManagerName" align="center" width="100"/>
        <a-table-column title="配合生产院" data-index="coopCompanyName" align="center" width="120"/>
        <a-table-column title="备注" data-index="remark" width="140">
          <template slot-scope="text">
            <a-tooltip :title="text">
              <span>{{ text }}</span>
            </a-tooltip>
          </template>
        </a-table-column>
        <a-table-column title="创建时间" data-index="createAt" align="center" width="160"/>
        <a-table-column title="更新时间" data-index="updateAt" align="center" width="160"/>
        <a-table-column title="操作" align="center" width="140" fixed="right">
          <template slot-scope="text, record">
            <a @click="handleDetail(record)">详情</a>
            <a-divider type="vertical"/>
            <a @click="handleEditRow(record)">编辑</a>
          </template>
        </a-table-column>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import axios from "axios";
import {mapGetters, mapMutations} from "vuex";
import watermark from "@/mixins/watermark";
import organization from "@/mixins/organization";
import download from "@/api/download";
import {saveAs} from "file-saver";
import {
  getProjectTrackList,
  deleteProjectTrack,
  getDeptAreaList,
} from "@/api/market/projectTrack";

const instance = axios.create({
  responseType: "blob",
});

function upload(data) {
  return instance({
    url: "/market-service/market/projectTrack/import",
    method: "post",
    headers: {
      token: window.localStorage.getItem("token"),
    },
    data,
  });
}

function exportFile(data) {
  return download({
    url: "/market-service/market/projectTrack/export",
    method: "get",
    data,
  });
}


export default {
  mixins: [watermark, organization],
  data() {
    return {
      form: {
        deptId: undefined,
      },
      loading: false,
      uploading: false,
      current: 1,
      pageSize: 10,
      list: [],
      total: 0,
      selectedRowKeys: [],
      selectedRows: [],
      orgList: [],
    };
  },
  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    projectTrackType() {
      return this.findDataDict("projectTrackType");
    },
    trackCategory() {
      return this.findDataDict("trackCategory");
    },
  },
  mounted() {
    this.getList();
    getDeptAreaList().then((res) => {
      this.orgList = Array.isArray(res) ? res : (res.list || []);
    });
  },
  methods: {
    ...mapMutations("tabs", ["setTabList"]),
    dictName(list, value) {
      const item = list.find((i) => i.value === value);
      return item ? item.name : value;
    },
    getList() {
      const {current, pageSize, form} = this;
      this.loading = true;
      const params = {...form};
      delete params.deptId;
      if (form.deptId) {
        const selected = this.orgList.find(item => item.id === form.deptId);
        if (selected) {
          if (selected.type === 'area') {
            params.registerAreaId = form.deptId;
          } else if (selected.type === 'dept') {
            params.registerOrgId = form.deptId;
          }
        }
      }
      getProjectTrackList({
        pageNum: current,
        pageSize,
        ...params,
      })
          .then((res) => {
            if (Array.isArray(res.list)) {
              this.list = Object.freeze(res.list);
              this.total = res.totalSize;
            }
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getList();
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    query() {
      this.current = 1;
      this.getList();
    },
    reset() {
      this.form = {};
      this.current = 1;
      this.getList();
    },
    handleAdd() {
      const tabPath = this.$route.path + "/add";
      const fullPath = tabPath;
      const tabList = [...this.$store.state.tabs.tabList];
      if (!tabList.some(item => item.path === tabPath)) {
        tabList.push({name: "新增项目跟踪", path: tabPath, fullPath});
        this.setTabList(tabList);
      }
      this.$router.push(fullPath).catch(() => {
      });
    },
    handleEdit() {
      if (this.selectedRows.length !== 1) {
        this.$message.warning("请选择一条记录");
        return;
      }
      const id = this.selectedRows[0].id;
      const tabPath = this.$route.path + "/edit";
      const fullPath = tabPath + "?id=" + id;
      const tabList = [...this.$store.state.tabs.tabList];
      if (!tabList.some(item => item.path === tabPath)) {
        tabList.push({name: "编辑项目跟踪", path: tabPath, fullPath});
        this.setTabList(tabList);
      }
      this.$router.push(fullPath).catch(() => {
      });
    },
    handleEditRow(row) {
      const id = row.id;
      const tabPath = this.$route.path + "/edit";
      const fullPath = tabPath + "?id=" + id;
      const tabList = [...this.$store.state.tabs.tabList];
      if (!tabList.some(item => item.path === tabPath)) {
        tabList.push({name: "编辑项目跟踪", path: tabPath, fullPath});
        this.setTabList(tabList);
      }
      this.$router.push(fullPath).catch(() => {
      });
    },
    handleDetail(row) {
      const id = row.id;
      const tabPath = this.$route.path + "/detail";
      const fullPath = tabPath + "?id=" + id;
      const tabList = [...this.$store.state.tabs.tabList];
      if (!tabList.some(item => item.path === tabPath)) {
        tabList.push({name: "项目跟踪详情", path: tabPath, fullPath});
        this.setTabList(tabList);
      }
      this.$router.push(fullPath).catch(() => {
      });
    },
    handleDelete() {
      if (this.selectedRows.length === 0) {
        this.$message.warning("请至少选择一条记录");
        return;
      }
      const that = this;
      this.$confirm({
        title: "确认要删除所选记录吗？",
        onOk() {
          const ids = that.selectedRows.map((r) => r.id);
          Promise.all(ids.map((id) => deleteProjectTrack(id))).then(() => {
            that.selectedRowKeys = [];
            that.selectedRows = [];
            that.getList();
          });
        },
      });
    },
    handleExport() {
      this.loading = true;
      const {form} = this;
      const params = {...form};
      delete params.deptId;
      if (form.deptId) {
        const selected = this.orgList.find(item => item.id === form.deptId);
        if (selected) {
          if (selected.type === 'area') {
            params.registerAreaId = form.deptId;
          } else if (selected.type === 'dept') {
            params.registerOrgId = form.deptId;
          }
        }
      }
      exportFile({
        pageNum: this.current,
        pageSize: this.pageSize,
        ...params,
      })
          .then((blob) => {
            saveAs(blob, "项目跟踪.xlsx");
            this.loading = false;
          });
    },
    handleDownloadTemplate() {
      window.open("https://portal.njszy.com/api/common-service/file/market/project_tracking_template.xlsx");
    },
    handleImport() {
      this.$refs.upload.click();
    },
    onFileChange(e) {
      const files = e.target.files;
      const data = new FormData();
      for (let i = 0; i < files.length; i++) {
        data.append("file", files[i]);
      }
      this.uploading = true;
      upload(data)
          .then((res) => {
            this.getList();
            const link = document.createElement("a");
            let blob = new Blob([res.data]);
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", "结果" + files[0].name);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
          })
          .finally(() => {
            this.uploading = false;
            e.target.value = null;
          });
    },
  },
};
</script>

<style lang="less" scoped>
.toolbar {
  margin-bottom: 12px;

  button {
    margin-right: 8px;
  }
}

::v-deep .ant-table-tbody > tr > td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

::v-deep .ant-table-fixed-left,
::v-deep .ant-table-fixed-right {
  .ant-table-header,
  .ant-table-body,
  .ant-table-placeholder {
    background: #fff;
  }
}

::v-deep .ant-table-fixed-left .ant-table-body > table > tbody > tr > td,
::v-deep .ant-table-fixed-right .ant-table-body > table > tbody > tr > td {
  background: #fff;
  position: relative;
  z-index: 1;
}

::v-deep .ant-table-fixed-left .ant-table-header > table > thead > tr > th,
::v-deep .ant-table-fixed-right .ant-table-header > table > thead > tr > th {
  background: #fafafa;
  position: relative;
  z-index: 2;
}
</style>
